// EntityView.tsx
import { SubduedLabel } from 'components/Labels'
import { useState } from 'react'
import { Data } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { SpacingEnum } from 'types/cssTypes'
import { formatPhoneNumber } from 'utils'
import { SlotData } from 'utils/dataExtractor'
import { formatDateOnly } from 'utils/date'
import { ClaimEditExtractedModal } from '../../ClaimEditExtractedInfoModal'
import { EDITABLE_PHONE_SLOTS } from './EntityVersions'

export const EntityView = (slotData: SlotData) => {
  const [modalShow, setModalShow] = useState(false)
  const [entity, setEntity] = useState<SlotData>()
  const editEntity = (slotData: SlotData) => {
    setEntity(slotData)
    setModalShow(true)
  }

  return (
    <>
      <Row className="label-set-container" data-slot={slotData.slot}>
        <div className="title">
          <SubduedLabel
            dataTestId={slotData.slot}
            labelId={slotData.typeId}
            text={slotData.description || slotData.slot}
          />
        </div>
        <div className="value">
          {EDITABLE_PHONE_SLOTS.includes(slotData.slot) ? (
            <div onClick={() => editEntity(slotData)}>
              <Data
                value={slotData.value! ? formatPhoneNumber(slotData.value!) : '---'}
                type="default"
                editable={true}
              />
            </div>
          ) : slotData.typeId === 'dateonly' ? (
            slotData.value! ? (
              formatDateOnly(slotData.value!)
            ) : (
              '---'
            )
          ) : (
            slotData.value || '—'
          )}
        </div>
      </Row>
      <ClaimEditExtractedModal show={modalShow} setShow={setModalShow} detail={entity!} />
    </>
  )
}

const Row = styled.div`
  margin-right: ${({ theme }) => theme.spacing[SpacingEnum.l]};

  .title {
    ${({ theme }) => theme.typography.xxs.medium};
    margin-bottom: ${({ theme }) => theme.spacing[SpacingEnum.xxxs]};
  }

  .value {
    ${({ theme }) => theme.typography.m.medium};
    color: ${({ theme }) => theme.colors.grey.dark};
    word-break: break-word;
    white-space: pre-line; /* preserves newline for multi-line groups */
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    font-style: normal;
  }
`
